module.exports = __webpack_public_path__ + "static/media/pause.db28a0c0.svg";